import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
import { environment } from '../../../environments/environment.development';
import { map, catchError, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { Subject } from 'rxjs';
import { User } from '../Models/User';
import { ConsentToAccessService } from '../../module/consent-to-access/consent-to-access.service';
import { Router } from '@angular/router';
import { EncryptionService } from './encryption.service';
import { AesGcmEncryptionService } from './aes-gcm-encryption.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  // Base URL of the token refresh API endpoint
  private refreshTokenUrl = environment.AuthApi + '/api/Auth/GetRefreshAccessToken';
  private tokenExpirationTime: number = 120; //  2 minte
  private settingValue: number = 2; //  5 minte
  userdata: any;

  constructor(private http: HttpClient,private consentManag:ConsentToAccessService,protected encryptionService: EncryptionService,
    protected aesGcmEncryptionService:AesGcmEncryptionService,
    private router: Router) {
      var accessTime = (this.settingValue) * 60; //Convert the data from Minute - 3 to Seconds
      //sessionStorage.removeItem("refreshTokenTime");
      //sessionStorage.setItem("refreshTokenTime", (Date.now() + accessTime * 1000).toString());

    const curUser = sessionStorage.getItem('userData');
    if(curUser){
      this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(curUser));
    }
    //this.setTokerExpiration();

    // this.currentUser = this.currentUserSubject.asObservable();
   }
  //  public setTokerExpiration(){
  //   this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('currentUser') || '{}'));
  //   this.currentUser = this.currentUserSubject.asObservable();
  //   if(this.currentUserSubject.value.token){
  //     const token = this.currentUserSubject.value.token;
  //     const decodedToken: any = jwtDecode.jwtDecode(token);
  //     this.tokenExpiration = decodedToken.exp;;
  //     // console.log('Set',this.tokenExpiration);
  //     this.checkTokenExpiration();
  //   }
  // }
  public getIPAddress() {
    return this.http.get("https://api.ipify.org/?format=json");
  }
  public loginOpenID(data: any) {
    return this.http.post<any>(environment.AuthApi + '/auth/loginOpenID', data)
      .pipe(map((result: any) => {
        return result;
      }));
  }
  public loginOpenIDConsent(data: any) {
    return this.http.post<any>(environment.ConsentAuthApi + '/auth/loginOpenID', data)
      .pipe(map((result: any) => {
        return result;
      }));
  }
  public departmentLogin(data: any) {
    return this.http.post<any>(environment.DepartmentSSOAPI + 'Auth/loginOpenID', data)
      .pipe(map((result: any) => {
        return result;
      }));
  }
   public loginOpenIDVLE(data: any) {
    return this.http.post<any>(environment.AuthApi + '/auth/loginOpenIDVLE', data)
      .pipe(map((result: any) => {
        return result;
      }));
  }
  // Method to refresh the token
  public refreshToken1(data): Observable<any> {
    // Make an HTTP request to the token refresh endpoint
    return this.http.post(this.refreshTokenUrl, data).pipe(
      // Handle successful response
      tap((response: any) => {
        // Update the access token in local storage or wherever it's stored
        // For example:
        // sessionStorage.setItem('accessToken', response.accessToken);
      }),
      // Handle error response
      catchError(error => {
        // Handle token refresh error
        // For example, redirect to login page or log the error
        // Example:
        // console.error('Error refreshing token:', error);
        throw error; // Re-throw the error to propagate it to the caller
      })
    );
  }

  public refreshToken():void {
    console.log(sessionStorage.getItem('userData'));
    // let clientobject = { 'clientid': this.currentUserValue.clientid };

    // //Here First need to update the RefreshToken Local Storage
    // this.clientService.readCyberSecurityData(clientobject).subscribe((data:any) => {
    //  if (data.length == 2) {
    //    var accessTime = (parseInt(data[0].settingvalue) - 2) * 60; //Convert the data from Minute - 3 to Seconds
    //    sessionStorage.removeItem("refreshTokenTime");
    //    sessionStorage.setItem("refreshTokenTime", (Date.now() + accessTime * 1000).toString());
    //  }
    // });

    //Then need to call and refresh the token
    //sessionStorage.setItem('userData','{"sub":null,"email":"taha@amnex.com","preferred_username":null,"name":"taha123","dob":null,"given_name":null,"family_name":null,"updated_at":"0001-01-01T00:00:00","idToken":"eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJlbUlEQU0iLCJzdWIiOiJ0YWhhMTIzIiwibmFtZSI6InRhaGExMjMiLCJhdWQiOiI1M2FkMTI1N2I0YzRiM2MzNDg0YzRhOGVlZjdhMjYzNDQ5YWQ5ZCIsInNjb3BlIjoidXNlciIsImVtYWlsIjoidGFoYUBhbW5leC5jb20iLCJtb2JpbGVOdW0iOiI5ODY3ODIzMjU2IiwiZXhpc3RpbmdVc2VyTmFtZSI6IiIsImFjY2Vzc01vZGUiOiJ3cml0ZSIsImlhdCI6MTcxMzkzNDkwNiwiZXhwIjoxNzEzOTM1MDI2fQ.Y_sv_0EoqiPFT7xBzvMXJgaN9aKijdxBMBLcdloHvnU","access_token":"857319e37baa6917db98864649de59da77c3495","refresh_token":"6e83f311fb1db1d8bb14109af1c593279ad52185","mobile":"9867823256","authorizationCode":"IKPgQTttCrauLkBc1hQUTEP/MCiZWmgkBVKJKg8IpzrI4oof0fbPEq6CvTBO2N7brMgHVdI1F8uyPiUDn05/DVHb4N/jOutFdi6KBQ157ijLV0QvBGbjzNhC//NK 21C1BpSC9vXRJ5Ok2JBE9qKSp/fmdpNA c7ga7sDjNFuuIWQGeKU2BrADpdB1GoCkciBXLal4oM XsNDi3Jjg1S  1rddVG5BvXpgNj ycnMjgbop5o8S3jPXwYV0vQZ7YXY6hXVQ5bxiIadmVT60/x9B4AkU8TEkT/YnsBCvLJMcYHacQMltmp8fknZvVzh//7O9Mdh6ZsyymXLOm0plptkA=="}')
    if (sessionStorage.getItem('userData') != null) {

      const refreshUserTokens = JSON.parse(sessionStorage.getItem('userData') || '{}');
      let body = {
        refresh_token: refreshUserTokens.refresh_token,
        authorizationCode: refreshUserTokens.authorizationCode

      };
    //this.http.post<any>(this.refreshTokenUrl,JSON.stringify(body))
    //.pipe(map((result: any) => {
    //  return result;
    //}));
      this.http.post<any>(environment.AuthApi + '/auth/GetRefreshAccessToken',body).subscribe(
        (data:any) => {
          if (data!='{}' && data.error != "Invalid Refresh Token") {
            //debugger;
            this.consentManag.isLoggedIn = true;
            refreshUserTokens.token = data.accessToken;
            refreshUserTokens.refreshToken = data.refreshToken;
            //sessionStorage.removeItem('userData');
            //sessionStorage.setItem('userData', JSON.stringify(data));
            //debugger;
            let existingData = sessionStorage.getItem('userData');
            let parsedData = existingData ? JSON.parse(existingData) : {};
            if (parsedData.hasOwnProperty("access_token")) {
              parsedData["access_token"] = data.access_token;
            }
            if (parsedData.hasOwnProperty("refresh_token")) {
              parsedData["refresh_token"] = data.refresh_token;
            }
            if (parsedData.hasOwnProperty("expiretime")) {
              parsedData["expiretime"] = data.expiretime;
              sessionStorage.setItem("_expiredTime", (Date.now() + data.expiretime * 1000).toString());
              const refreshTokenTime = Date.now() + (data.expiretime * 2) * 1000;
              sessionStorage.setItem("refreshTokenTime", refreshTokenTime.toString());
            }
            //sessionStorage.setItem('userData', JSON.stringify(data));
            sessionStorage.setItem('userData', JSON.stringify(parsedData));
          }
          else{
            var data: any = sessionStorage.getItem('userData');
            data = JSON.parse(data);
            sessionStorage.removeItem('userData');
            this.consentManag.isLoggedIn = false;
            console.log(this.IDAMlogOut(data.idToken));
            this.IDAMlogOut(data.idToken);
            this.router.navigate(['/home/landing']);
          }
        }
      );
    }
  }

  // Method to check if the token is expired
  public isTokenExpired(): boolean {
    const currentTime = new Date().getTime()/ 1000;
    return this.tokenExpirationTime < currentTime;
  }
  public LoginPostOIDC(data: any) {
    return this.http.post<any>(environment.AuthApi + '/auth/LoginPostOIDC', data)
      .pipe(map((result: any) => {
        return result;
      }));
  }
  public saveProfileData(data: any) {
    this.userdata = JSON.parse(sessionStorage.getItem('userData') || '{}');
    console.log(this.userdata);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.userdata.access_token}`
    });
    return this.http.post<any>(environment.AuthApi + '/auth/ChangePassword', data,{headers})
      .pipe(map((result: any) => {
        return result;
      }));
  }
  public getMyApplicationAccess(data: any) {
     this.userdata = JSON.parse(sessionStorage.getItem('userData') || '{}');
    console.log(this.userdata);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.userdata.access_token}`
    });

    return this.http.post<any>(environment.AuthApi + '/auth/GetMyApplicationAccess', data,{headers})
      .pipe(map((result: any) => {
        return result;
      }));
  }

  public getToken(code: any) {
    return this.http.get<any[]>(environment.AuthApi + '/auth/GetToken' + '?code=' + code);
  }
  public IDAMlogOut(idToken: any) {
    return this.http.get<any[]>(environment.AuthApi + '/auth/Logout' + '?id_token=' + idToken);
  }
  public menuitems: any = [
    { path: '', text: 'HOME' },
    { path: '/test', text: 'ABOUT MAHA SAMANVAY' },
    { path: '/test', text: 'SCHEMES' },
    { path: '/test', text: 'GALLERY' },
    { path: '/test', text: 'CONTACT US' },
    { path: '/test', text: 'FAQs' },

  ];
  public citizenmenuitems() {

  }

  public saveProfileImage(data: any) {
    return this.http.post<any>(environment.MasterAPI + 'Profile/SaveProfile', data)
      .pipe(map((result: any) => {
        return result;
      }));
  }
  updateUserMasterData(data: any): Observable<any> {
    this.userdata = JSON.parse(sessionStorage.getItem('userData') || '{}');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.userdata.token}`
    });

    return this.http.post<any>(environment.MasterAPI + 'Profile/UpdateProfile', data, { headers })
      .pipe(
        map((result: any) => result)
      );
  }

  public getProfileImage(data: any) {
    const payload = {
    username: this.encryptionService.encrypt(data.username),
    citizen_unique_id: this.encryptionService.encrypt(data.citizen_unique_id)
    };

    return this.http.post<any>(environment.MasterAPI + 'Profile/GetProfile',  payload)
      .pipe(map((result: any) => {
        return result;
      }));
  }

  async fn_GetProfileData(data: any) {
    const payload = {
    username: await this.aesGcmEncryptionService.encrypt(data.username),
    citizen_unique_id: await this.aesGcmEncryptionService.encrypt(data.citizen_unique_id)
    };

    return await  this.http.post<any>(environment.MasterAPI + 'Profile/GetProfileData',  payload).toPromise();

  }

  private logoutSubject = new Subject<void>();
  logoutObservable = this.logoutSubject.asObservable();
  triggerLogout() {
    this.logoutSubject.next();
  }
  // public checkTokenValidity(data: any) {
  //   var request = JSON.stringify(data);
  //   return this.http.post<any>('https://dev-emudhra.amnex.co.in/emIDAM/oauth/checkTokenValidity', request)
  //     .pipe(map((result: any) => {
  //       return result;
  //     }));
  // }
  private tokenValidationUrl = 'https://dev-emudhra.amnex.co.in/emIDAM/oauth/checkTokenValidity'; // Your API endpoint
  // Method to check token validity
  checkTokenValidity(tokenPayload: { accessToken: string, userid: string }): Observable<boolean> {
    return this.http.post<boolean>('https://dev-emudhra.amnex.co.in/emIDAM/oauth/checkTokenValidity', tokenPayload).pipe(
      catchError(error => {
        console.error('Error during token validation:', error);
        return throwError(() => new Error('Token validation failed')); // Handle errors gracefully
      })
    );
  }
    public eKycProcessModel(data: any) {
    return this.http.post<any>(environment.AuthApi + '/auth/EKycProcess', data)
      .pipe(map((result: any) => {
        return result;
      }));
  }

   public fn_DownloadPDFProfile(data: any) {
  return this.http.post(environment.MasterAPI + 'Profile/DownloadPDFProfile', data, {
    responseType: 'blob' as 'json'   // 👈 important fix
  });
}
public fn_DownloadPDFProfileimage(data: any) {
  return this.http.post<any>(
    environment.MasterAPI + 'Profile/DownloadPDFProfileimage',
    data
  );
}


  // public citizenmenuitems: any = [
  //   { path: '', text: 'My Dashboard' },
  //   { path: '/test', text: 'My Profile' },

  // ];
  uploadFile(file: File, accessToken: string, path: string) {
   const formData = new FormData();
   formData.append("file", file);

   let params = new HttpParams()
     .set("accessToken", accessToken)
     .set("path", path);

   return this.http.post(environment.CommonAPI+'DigiLocker/UploadToDigiLocker', formData, { params });
 }
     public getUserProgress(data: any) {
    return this.http.post<any>(environment.MasterAPI + 'Profile/GetUserProgress', data)
      .pipe(map((result: any) => {
        return result.value;
      }));
  }

  public fn_AddBearerTokenAuditLog(data: any) {
  return this.http.post<any>(
    environment.MasterAPI + 'AuditLog/AddBearerTokenAuditLog',
    { bearertoken: data }   // ✅ FIX
  ).pipe(
    map((result: any) => {
      return result.value;
    })
  );
}

public loginMahaSSO(data: any) {
    return this.http.post<any>(environment.MahaSSOAuthApi + '/auth/loginOpenID', data)
      .pipe(map((result: any) => {
        return result;
      }));
  }
}
